import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-teal-950 text-teal-100 py-14">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-display text-2xl text-white mb-3">Serenidad</p>
          <p className="text-teal-300 text-sm leading-relaxed">
            Psicología clínica especializada en adultos.<br />Un espacio seguro para sanar.
          </p>
        </div>
        <div>
          <p className="text-teal-400 text-xs uppercase tracking-widest mb-4">Navegación</p>
          <ul className="space-y-2">
            {[['/', 'Inicio'], ['/servicios', 'Servicios'], ['/equipo', 'Equipo'], ['/contacto', 'Contacto']].map(([path, label]) => (
              <li key={path}>
                <Link to={path} className="text-teal-200 text-sm hover:text-white transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-teal-400 text-xs uppercase tracking-widest mb-4">Contacto</p>
          <p className="text-teal-200 text-sm">hola@serenidadpsychology.com</p>
          <p className="text-teal-200 text-sm mt-1">+1 (555) 000-0000</p>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 mt-10 pt-6 border-t border-teal-900 text-teal-500 text-xs">
        © {new Date().getFullYear()} Serenidad Psychology. Todos los derechos reservados.
      </div>
    </footer>
  );
}